import { watch } from "vue";
import { locales } from "../plugins/i18n";
import { useI18n } from "vue-i18n";

export function useLocale() {
  const locale = useCookie<string | undefined>("locale", {
    default: () => navigator?.language?.substring(0, 2) ?? "de"
  });
  const i18n = useI18n();

  watch(
    locale,
    (locale) => {
      if (!locale) return;
      i18n.locale.value = locale;
    },
    { immediate: true }
  );

  return { locales, locale };
}
